"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGroupPermission = exports.isJoinablePermission = exports.strToRegion = exports.regions = exports.regionToStr = void 0;
exports.isJoinableLocationInfo = isJoinableLocationInfo;
exports.regionToStr = {
    us: "",
    jp: "~region(jp)",
    eu: "~region(eu)",
};
exports.regions = Object.keys(exports.regionToStr);
exports.strToRegion = exports.regions.reduce(function (h, t) {
    var _a;
    return (__assign(__assign({}, h), (_a = {}, _a[exports.regionToStr[t]] = t, _a)));
}, {});
exports.isJoinablePermission = {
    public: true,
    "friends-plus": true,
    friends: true,
    "invite-plus": true,
    invite: true,
    "group-public": true,
    "group-plus": true,
    group: true,
};
exports.isGroupPermission = {
    "group-public": true,
    "group-plus": true,
    group: true,
};
function isJoinableLocationInfo(info) {
    return exports.isJoinablePermission[info.permission] || false;
}
